import { render, staticRenderFns } from "./AppDictSearch.vue?vue&type=template&id=570c903e"
import script from "./AppDictSearch.vue?vue&type=script&lang=js"
export * from "./AppDictSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports